/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getParcelProviders } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

type GetParcelProviderListOptions = {
  location: string;
  options?: UseQueryOptions;
  [key: string]: any;
};

export const useGetParcelProviderList = (options: GetParcelProviderListOptions) => {
  const { location, options: queryOptions, ...filters } = options;
  return useQuery({
    queryKey: userQueryKeys.parcelProviderListing(location, filters),
    queryFn: ({ signal }) => getParcelProviders(location, { params: filters, signal }).then((res) => res.data),
    ...queryOptions,
  });
};
